import discount from './discount.gif';
import loader from './loader.gif';
import estrellas from './estrellas.gif';

export const Animations = {
  discount,
  loader,
  estrellas
};
